import "../styles/about.css";


import Carousel from "react-bootstrap/Carousel";
import { Link } from "react-router-dom";

import shop1 from "../assets/images/shop1.jpeg";
import shop7 from "../assets/images/shop7.jpeg";
import shop3 from "../assets/images/shop3.jpeg";
import shop4 from "../assets/images/shop4.jpeg";
import shop5 from "../assets/images/shop5.jpeg";


function About() {

  return (
    <>



      {/* ================= Hero ================= */}

      <section className="about-hero" data-aos="fade-up">

        <div className="about-overlay"></div>

        <div className="about-container">

          {/* Left */}

          <div className="about-content">

            <h1>About Us</h1>

            <p>
              Welcome to Jagadish Hearing Aids, One of the leading provider of hearing
              aids and hearing healthcare solutions. Our mission is to help
              people with hearing loss achieve a better quality of life by
              providing them with the latest hearing technology and expert care.
            </p>

            <p>
              We understand that hearing loss can have a significant impact on a
              person's daily life, affecting their ability to communicate,
              socialize and enjoy the world around them.
            </p>

            <p>
              Our experienced audiologists and hearing healthcare professionals
              are committed to providing personalized care and support to every
              customer.
            </p>

            <p>
              We offer a wide range of hearing aids from leading manufacturers
              along with complete hearing evaluations and maintenance services.
            </p>

            <p>
              Our goal is to ensure every customer experiences better hearing
              and a better quality of life.
            </p>

          </div>

          {/* Right */}

          <div className="about-showcase-container">

            <h3>Gallery</h3>

            <Carousel fade interval={2000}>

              <Carousel.Item>
                <img src={shop1} className="d-block w-100" alt="" />
              </Carousel.Item>

              <Carousel.Item>
                <img src={shop7} className="d-block w-100" alt="" />
              </Carousel.Item>

              <Carousel.Item>
                <img src={shop3} className="d-block w-100" alt="" />
              </Carousel.Item>

              <Carousel.Item>
                <img src={shop4} className="d-block w-100" alt="" />
              </Carousel.Item>

              <Carousel.Item>
                <img src={shop5} className="d-block w-100" alt="" />
              </Carousel.Item>


            </Carousel>

            <Link to="/gallery">

              <Link to="/gallery" className="gallery-btn">
                View More
              </Link>

            </Link>

          </div>

        </div>

      </section>

      {/* ================= Since 1988 ================= */}

      {/* <section className="since-section">

        <div className="since-left">

          <h2>Since 1988</h2>

        </div>

        <div className="since-right">

          <p>
            Jagadish Hearing Aids was founded in 1988 by
            <strong> Mr. C. K. Jagadish</strong>, a passionate audiologist
            with a vision to provide exceptional hearing healthcare to
            individuals with hearing loss.
          </p>

          <p>
            Over the years, we have grown into one of Chennai's trusted
            hearing healthcare centers, helping thousands of people regain
            confidence through better hearing.
          </p>

          <p>
            We provide complete hearing evaluations, hearing aid fitting,
            programming, repairs, maintenance, and long-term hearing care
            support using the latest technology from leading manufacturers.
          </p>

        </div>

      </section> */}

      {/* ================= Hearing Section ================= */}

      <section className="hearing-section" data-aos="zoom-in">

        <div className="hearing-content">

          <h2>Why Hearing Matters</h2>

          <p>
            Of all the six senses, hearing is one of the most precious.
            When hearing is affected, communication becomes difficult,
            relationships suffer, and social interaction slowly decreases.
          </p>

          <p>
            At Jagadish Hearing Aids, we believe everyone deserves the joy
            of hearing clearly. Our experienced audiologists are committed
            to helping every patient reconnect with family, friends,
            and the world around them.
          </p>

        </div>

      </section>

      {/* ================= Footer ================= */}



    </>
  );
}

export default About;